import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';

const RegionMode = ({effect, selected, width, height}) => { 
    let _selected = selected.flatMap(
        x => x.isPlaneMacro ? x.parameters : x);
    return (
        <g>
          {_selected
           .map(
            ({min, max, originalMin, originalMax, depthParameter}) =>
                   <rect
                     className="region-bounds"
                     x={width * (min - originalMin) / (originalMax - originalMin)}
                     y={depthParameter ? height * (depthParameter.min - depthParameter.originalMin) / (depthParameter.originalMax - depthParameter.originalMin) : 0}
                     height={depthParameter ? height * (depthParameter.max - depthParameter.min) / (depthParameter.originalMax - depthParameter.originalMin) : height}
                     width={width * (max - min) / (originalMax - originalMin)}/>)}
        </g>);
}

const mapStateToProps = (state, props) => {
  return {
      parameterMinMax: state.effects.parameterMinMax
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RegionMode);
